import {
  Mitarbeiter_GetFeiertagskontoQuery,
  Mitarbeiter_GetFeiertagskontoQueryVariables,
} from '@/gql/graphql';
import { gql, TypedDocumentNode } from '@apollo/client';

export const GET_FEIERTAGSKONTO: TypedDocumentNode<
  Mitarbeiter_GetFeiertagskontoQuery,
  Mitarbeiter_GetFeiertagskontoQueryVariables
> = gql`
  query mitarbeiter_getFeiertagskonto(
    $standortIds: [String!]!
    $zeitraum: mitarbeiter_zeitraum!
  ) {
    mitarbeiter_mitarbeiterByStandortIds(standortIds: $standortIds) {
      uid
      vorname
      nachname
      feiertagskontoEinstellungen {
        isFeiertagskontoEnabled
      }
      feiertagskonto(zeitraum: $zeitraum) {
        kontostand
        uebertragAusVorjahr
        kontoausgleiche {
          art
          bemerkung
          datum
          tage
        }
      }
    }
  }
`;
